import { useState } from "react";
import { motion } from "framer-motion";
import { Play } from "lucide-react";

const VideoSection = () => {
  const [loaded, setLoaded] = useState(false);

  return (
    <section className="py-20 md:py-28">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-10">

          <h2 className="text-3xl sm:text-4xl font-display font-bold mb-4">
            See <span className="text-gradient">AdV3nture</span> in Action
          </h2>
          <p className="text-muted-foreground max-w-xl mx-auto">
            Watch how we connect founders with the right investors: fast, smart, and at scale.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.15 }}
          className="max-w-4xl mx-auto">

          <div
            style={{
              position: "relative",
              width: "100%",
              height: 0,
              paddingTop: "56.25%",
              borderRadius: "12px",
              overflow: "hidden",
              boxShadow: "0 0 40px hsl(174 62% 47% / 0.15), 0 4px 24px rgba(0,0,0,0.4)"
            }}>

            {loaded ? (
              <iframe
                style={{
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                  top: 0,
                  left: 0,
                  border: "none",
                  padding: 0,
                  margin: 0
                }}
                src="https://www.canva.com/design/DAHAQzXE_eY/nEl590vkwZwJavTHqRi-2g/watch?embed&autoplay=1"
                allowFullScreen
                allow="fullscreen; autoplay"
                referrerPolicy="no-referrer-when-downgrade"
                title="adv3nture product demo" />
            ) : (
              <button
                onClick={() => setLoaded(true)}
                aria-label="Play AdV3nture product demo"
                style={{
                  position: "absolute",
                  inset: 0,
                  width: "100%",
                  height: "100%",
                  background: "linear-gradient(135deg, hsl(220 20% 10%), hsl(210 30% 8%))",
                  border: "none",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                  gap: "16px"
                }}>
                <div style={{
                  width: "72px",
                  height: "72px",
                  borderRadius: "50%",
                  background: "hsl(174 62% 47% / 0.15)",
                  border: "2px solid hsl(174 62% 47% / 0.5)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backdropFilter: "blur(8px)",
                  boxShadow: "0 0 30px hsl(174 62% 47% / 0.3)"
                }}>
                  <Play size={28} style={{ color: "hsl(174, 62%, 47%)", marginLeft: "4px" }} fill="hsl(174, 62%, 47%)" />
                </div>
              </button>
            )}

          </div>
        </motion.div>
      </div>
    </section>);

};

export default VideoSection;